import {
  BlockControls,
  InspectorControls,
  JustifyContentControl,
  useBlockProps,
} from "@wordpress/block-editor";

import AllInspectorSettings from "./InspectorControls";

import "../style.scss";

export default function Edit(props) {
  const { attributes, setAttributes, clientId, blockAlignment } = props;

  return (
    <>
      <BlockControls group="block">
        <JustifyContentControl
          value={blockAlignment}
          onChange={(nextAlign) => {
            setAttributes({ blockAlignment: nextAlign });
          }}
          allowedControls={["left", "center", "right"]}
        />
      </BlockControls>
      <InspectorControls>
        <AllInspectorSettings
          setAttributes={setAttributes}
          attributes={attributes}
          clientId={clientId}
        />
      </InspectorControls>
      <Content {...props} />
    </>
  );
}

export function Content(props) {
  const { isSave = false, context, attributes } = props;

  const {
    defaultIcon,
    hoverIcon,
    activeIcon,
    backgroundColor,
    backgroundColorHover,
    backgroundColorActive,
    textColor,
    textColorHover,
    textColorActive,
    iconPosition,
    iconGap,
    iconSize,
    blockAlignment,
  } = props.attributes;

  const useIcon = attributes.useIcon ?? true;

  const dataProps = {
    className: blockAlignment ? `has-block-alignment-${blockAlignment}` : "",
    "data-product-id": context?.postId ?? "",
    style: {
      "--atw-background-color": backgroundColor,
      "--atw-background-color-hover": backgroundColorHover,
      "--atw-background-color-active": backgroundColorActive,
      "--atw-text-color": textColor,
      "--atw-text-color-hover": textColorHover,
      "--atw-text-color-active": textColorActive,
      "--atw-icon-position": iconPosition,
      "--atw-icon-gap": iconGap,
      "--atw-icon-size": iconSize,
    },
  };

  const blockProps = isSave
    ? useBlockProps.save(dataProps)
    : useBlockProps(dataProps);

  // if (!isSave && (context?.postType !== "product" || !context?.postId)) {
  //   return <div {...blockProps}>There is no product found</div>;
  // }

  // Helper function to render icon
  const renderIcon = (iconObj, state) => {
    if (!useIcon || !iconObj.name) {
      return null;
    }

    const iconClass = `ph${
      iconObj.type !== "regular" ? "-" + iconObj.type : ""
    } ph-${iconObj.name}`;

    return (
      <i
        className={`wp-block-brandy-add-to-wishlist-icon ${state}-state ${iconClass}`}
      />
    );
  };

  return (
    <div {...blockProps}>
      <span className="wp-block-brandy-add-to-wishlist-loading"></span>
      <div
        className={`wp-block-brandy-add-to-wishlist-content icon-position-${iconPosition}`}
      >
        <div className="wp-block-brandy-add-to-wishlist-icon-wrap">
          {renderIcon(defaultIcon, "default")}
          {renderIcon(hoverIcon, "hover")}
          {renderIcon(activeIcon, "active")}
        </div>
        {(attributes.defaultText || attributes.addedText) && (
          <div className="wp-block-brandy-add-to-wishlist-text-wrap">
            {attributes.defaultText && (
              <span
                className="wp-block-brandy-add-to-wishlist-text default-state"
                dangerouslySetInnerHTML={{ __html: attributes.defaultText }}
              ></span>
            )}
            {attributes.addedText && (
              <span
                className="wp-block-brandy-add-to-wishlist-text active-state"
                dangerouslySetInnerHTML={{ __html: attributes.addedText }}
              ></span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
